import { Phone, Mail, MapPin, Send } from "lucide-react";
import { SHORT_DISCLAIMER } from "../../constants/disclaimer";
import { CONTACT } from "../../constants/contact";

export const Footer = ({ openForm }) => (
  <footer data-testid="footer-container" className="border-t border-slate-800 bg-[#0B1120] pb-24 pt-8 md:pb-6">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-12">
        <div className="lg:col-span-3">
          <p className="font-heading text-xl font-extrabold text-white">Balangir Group</p>
          <p className="mt-2 text-sm leading-relaxed text-slate-400">All-India B2B manpower, labour & security services aggregator.</p>
          <p className="mt-1.5 font-mono text-xs text-slate-500">balangirgroup.com</p>
        </div>
        <div className="lg:col-span-2">
          <p className="footer-h !text-xs">Platform</p>
          <ul className="mt-3 space-y-1.5 text-sm text-slate-400">
            {["services", "industries", "how-it-works", "calculator", "faq"].map((id) => (
              <li key={id}><a href={`#${id}`} data-testid={`footer-link-${id}`} className="capitalize hover:text-orange-400">{id.replace(/-/g, " ")}</a></li>
            ))}
          </ul>
        </div>
        <div className="lg:col-span-3">
          <p className="footer-h !text-xs">Get started</p>
          <ul className="mt-3 space-y-1.5 text-sm text-slate-400">
            <li><button data-testid="footer-cta-hire" onClick={() => openForm("employer")} className="hover:text-orange-400">Post a requirement</button></li>
            <li><button data-testid="footer-cta-worker" onClick={() => openForm("worker")} className="hover:text-orange-400">Register as employee / guard</button></li>
            <li><a href="/book" data-testid="footer-book-service" className="hover:text-orange-400">Book Service</a></li>
            <li><a href="/employer" data-testid="footer-employer-login" className="hover:text-orange-400">Employer Login</a></li>
            <li><a href="/worker" data-testid="footer-employee-login" className="hover:text-orange-400">Employee Login</a></li>
          </ul>
        </div>
        <div className="lg:col-span-4">
          <p className="footer-h !text-xs">Contact</p>
          <ul className="mt-3 space-y-2 text-sm text-slate-400">
            <li data-testid="footer-contact-phone" className="flex gap-2"><Phone className="mt-0.5 h-4 w-4 shrink-0" /><a href={CONTACT.phoneHref} className="hover:text-orange-400">{CONTACT.phone}</a></li>
            <li data-testid="footer-contact-email" className="flex gap-2"><Mail className="mt-0.5 h-4 w-4 shrink-0" /><a href={`mailto:${CONTACT.email}`} className="break-all hover:text-orange-400">{CONTACT.email}</a></li>
            <li data-testid="footer-contact-telegram" className="flex gap-2"><Send className="mt-0.5 h-4 w-4 shrink-0" /><a href={CONTACT.telegram} target="_blank" rel="noreferrer" className="hover:text-orange-400">Telegram: @balangirgroupp</a></li>
            <li data-testid="footer-contact-address" className="flex gap-2"><MapPin className="mt-0.5 h-4 w-4 shrink-0" />{CONTACT.address}</li>
            <li data-testid="footer-contact-person" className="pl-6 text-slate-500">Contact person: {CONTACT.name}</li>
          </ul>
        </div>
      </div>
      <div data-testid="footer-legal-disclaimer" className="mt-6 border-t border-slate-800 pt-4 text-xs leading-relaxed text-slate-400">
        <p><span className="font-semibold text-slate-300">Disclaimer: </span>{SHORT_DISCLAIMER}</p>
        <div className="mt-2 flex flex-wrap gap-x-5 gap-y-1">
          <a href="/disclaimer" data-testid="footer-disclaimer-link" className="font-semibold text-orange-400 hover:text-orange-300">Read full Legal Disclaimer →</a>
          <a href="/terms" data-testid="footer-terms-link" className="font-semibold text-slate-300 hover:text-white">Terms of Service</a>
          <a href="/privacy" data-testid="footer-privacy-link" className="font-semibold text-slate-300 hover:text-white">Privacy Policy</a>
        </div>
      </div>
      <p className="mt-2 text-xs text-slate-600">
        © {new Date().getFullYear()} Balangir Group. All rights reserved.
      </p>
    </div>
  </footer>
);
